import { computed, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: 'FilterBar',
  emits: ['open-filters', 'open-sort-by','close-sort-by'],
  setup(_: any, { emit }: any) {
    const isLocalEnvironment = window.location.hostname == 'localhost';
    const store = useStore();
    const isSortByOpen = computed(() => store.state.isSortByOpen);
    
    const handleFilterButtonClick = () => {
      emit('open-filters');
    };

    const handleSortByButtonClick = () => {
      const sortByButton = document.getElementById('sort-by-button');
      if (sortByButton) {
        if (!isSortByOpen.value) {
          sortByButton.classList.add("isActive");
          store.dispatch("setSortByOpened", true);
          emit('open-sort-by');
        } else {
          setTimeout(() => {
            sortByButton.classList.remove("isActive");
          },50)
          store.dispatch("setSortByOpened", false);
          emit('close-sort-by');
        }
      }
    };
    onMounted(() => {
      const externalFilterButton = document.getElementById('filters-button');
      const externalSortByButton = document.getElementById('sort-by-button');
      if (externalFilterButton) {
        externalFilterButton.addEventListener('click', handleFilterButtonClick);
      }
      if (externalSortByButton) {
        externalSortByButton.addEventListener('click', handleSortByButtonClick);
      }
    });

    // Opzionalmente, pulizia degli eventi quando il componente viene smontato
    onUnmounted(() => {
      const externalFilterButton = document.getElementById('filters-button');
      const externalSortByButton = document.getElementById('sort-by-button');
      if (externalFilterButton) {
        externalFilterButton.removeEventListener('click', handleFilterButtonClick);
      }
      if (externalSortByButton) {
        externalSortByButton.removeEventListener('click', handleSortByButtonClick);
      }
    });

    return {
      isLocalEnvironment
    };
  }
};
